import * as yup from 'yup';
import { Formik } from 'formik';
import { Box } from '@mui/material';
import { SecretField } from '@qrios/frontend-library';

import locales from '../../../../../../../../../constants/locales';
import WithFormLayout from '../../../../../../../../common/with-form-layout';
import { BusinessError } from '../../../../../../../../common/business-error';
import { OTP_VERIFICATION } from '../../../../../../../../../constants/formInputs';
import { otpSmsValidation } from '../../../../../../../../../constants/validation';

import { OtpValue } from '../interfaces';
import Typography from '../../../../../../../../common/typography';
import { AlertThatPreviousSecretsWillBeUnusable } from '../../../../../../../../common/common-alert-messages';

const validationSchema = yup.object().shape({
  [OTP_VERIFICATION.SMS]: otpSmsValidation
});

interface Props {
  onClose: () => void;
  loading: boolean;
  onSubmit: (otp: OtpValue) => void;
  error?: BusinessError | null;
  shortcodeToDial?: string;
  userMsisdnFromBackend?: string;
}

const OtpVerification = ({
  onClose,
  loading,
  onSubmit,
  error = null,
  shortcodeToDial,
  userMsisdnFromBackend
}: Props) => (
  <Formik
    initialValues={{
      [OTP_VERIFICATION.SMS]: ''
    }}
    validationSchema={validationSchema}
    onSubmit={values => {
      onSubmit(values);
    }}
  >
    {({ values, handleChange, handleSubmit, errors, touched, handleBlur }) => (
      <>
        <Box mb={2}>
          <AlertThatPreviousSecretsWillBeUnusable />
        </Box>
        <WithFormLayout
          submitLabel="Verify OTP and regenerate secrets"
          secondaryLabel="Close without update"
          onSubmit={handleSubmit}
          onSecondary={onClose}
          loading={loading}
          error={error}
          danger
        >
          <Box sx={{ display: 'flex', marginBottom: '8px' }}>
            <Typography color="#4A4A4A" size={14}>
              Enter the OTP you recived to &nbsp;
            </Typography>
            {userMsisdnFromBackend ? (
              <Typography size={14}>{userMsisdnFromBackend}</Typography>
            ) : (
              <Typography color="#4A4A4A" size={14}>
                your phone
              </Typography>
            )}
          </Box>
          <Box mb={1}>
            <SecretField
              name={OTP_VERIFICATION.SMS}
              value={values[OTP_VERIFICATION.SMS]}
              handleChange={handleChange}
              handleBlur={handleBlur}
              label=""
              error={errors[OTP_VERIFICATION.SMS]}
              touched={touched[OTP_VERIFICATION.SMS]}
              placeholder={locales.otp.label.sms}
            />
          </Box>
          {shortcodeToDial && (
            <Box sx={{ display: 'flex', marginBottom: '16px' }}>
              <Typography size={14} color="#4A4A4A">
                If you didn’t receive the previous OTP on your phone, you can also call &nbsp;
              </Typography>
              <Typography size={14} color="#00683E">
                {shortcodeToDial}
              </Typography>
            </Box>
          )}
        </WithFormLayout>
      </>
    )}
  </Formik>
);

export default OtpVerification;
